import React from "react";
import close from "../../../assets/images/model/close.svg"; // Update the path accordingly
import userInfo from "../../../assets/images/model/user-info.png"; // Update the path accordingly
import { useSelector } from "react-redux";

const ConfrimAuthors = ({
  setGotoConfrimAuthor,
  setUploadLoadingBook,
  selectChapter,
  formValues,
  upload,
  setThanksModel,
  uploadLoading,
}) => {
  const { user } = useSelector((state) => state.auth);
  return (
    <div
      className="modal custom_background custom_modal_create"
      id="confirm_authors"
      tabIndex="-1"
      style={{ display: "block" }}
      aria-labelledby="confirm_authorsLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src={close}
                alt="close"
                onClick={() => {
                  setGotoConfrimAuthor(false);
                  setUploadLoadingBook(false);
                }}
              />
            </button>
          </div>
          <div className="modal-body-cre">
            <h4>confirm authors</h4>
            <p>
              We want to make sure the authors of any book added to Greyled are
              accredited for their work.
            </p>
            <form action="" className="confirm_authors">
              <div className="confirm_authors my-40">
                <div className="row">
                  {formValues.isImAuthor ? (
                    <div className="col-md-6">
                      <div className="user_info_confrim">
                        <div className="user_img_info_conf">
                          {user.image ? (
                            <img src={user.image} alt="author" />
                          ) : (
                            <div
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "50%",
                              }}
                            >
                              <p
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginBottom: "0px",
                                  width: "100%",
                                  height: "100%",
                                  fontSize: "50px",
                                  fontWeight: "bolder",
                                  textTransform: "uppercase",
                                }}
                              >
                                {user.firstName[0]}
                                {user.lastName[0]}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="user_info_content_main">
                          <h5 style={{ textTransform: "capitalize" }}>
                            {user.firstName} {user.lastName}
                          </h5>
                          <small>{user.email}</small>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-6">
                      <div className="user_info_confrim">
                        <div className="user_img_info_conf">
                          {/* <img src="assets/images/user-info.png" alt="author"> */}
                        </div>
                        <div className="user_info_content_main">
                          <h5>Greyled invite to be sent</h5>
                          <small>{formValues.originalAuthor}</small>
                        </div>
                      </div>
                    </div>
                  )}
                  {formValues.collaborator && (
                    <div className="col-md-6">
                      <div className="user_info_confrim">
                        <div className="user_img_info_conf">
                          {/* <img src="assets/images/user-info.png" alt="author"> */}
                        </div>
                        <div className="user_info_content_main">
                          <h5>Greyled invite to be sent</h5>
                          <small>{formValues.collaborator}</small>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-btn">
                <button
                  type="button"
                  className="btn-black_create mb-24"
                  disabled={uploadLoading}
                  onClick={() => {
                    upload();
                  }}
                >
                  {uploadLoading ? "Uploading..." : "Yes, this is correct"}
                </button>
                <button
                  type="button"
                  className="btn-white-create"
                  onClick={() => {
                    setUploadLoadingBook(true);
                    setGotoConfrimAuthor(false);
                  }}
                >
                  Go back
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfrimAuthors;
